var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "camera_content" }, [
    _c("div", { staticClass: "camera-component" }, [
      _c("div", { staticClass: "camera-component__camera" }, [
        _c("div", { staticClass: "camera__description" }, [
          _c("h4", { staticClass: "headline-large-bold" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "camera__video" },
          [
            _c("ma-camera-component", {
              ref: "camera",
              on: { photosArray: _vm.handlePhotos },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "camera__footer" }, [
          _c("div", { staticClass: "camera-footer__controls" }, [
            _c(
              "div",
              { staticClass: "containerFileImg" },
              [
                _c("svgicon", {
                  attrs: {
                    name: "camera-create",
                    color: "#566473",
                    width: "24",
                    height: "24",
                  },
                }),
                _c("input", {
                  ref: "gallery",
                  staticClass: "file text-medium-light",
                  attrs: { type: "file", accept: ".jpg, .jpeg, .png" },
                  on: { change: _vm.handleChangeInput },
                }),
              ],
              1
            ),
            _c("div", {
              staticClass: "camera-capture",
              on: { click: _vm.takePhoto },
            }),
            _c(
              "button",
              {
                ref: "buttonFlip",
                staticClass: "change-camera",
                on: { click: _vm.switchCamera },
              },
              [
                _c("svgicon", {
                  attrs: {
                    name: "ico-switch",
                    color: "#566473",
                    height: "24",
                    width: "auto",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }